
























import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

@Component
export default class UploadArea extends Vue {
  @Prop() haveAttachments!: boolean

  @Prop({ type: Boolean, default: false }) disabled!: boolean

  @Prop({ type: String }) title!: string

  @Emit()
  onClick(e: MouseEvent): MouseEvent {
    return e
  }

  get uploadAreaTitle() {
    if (this.title) {
      return this.title
    } else {
      if (this.haveAttachments) {
        return this.$t('upload_media_description_small').toString()
      } else {
        return this.$t('upload_media_description_large').toString()
      }
    }
  }
}
